import forOwn from 'mout/object/forOwn'

/**
 * Counts the number of questions that have an answer associated with them thus far.
 * @param {object} answersByItem from userAssessment.answersByItem[subtestId] 
 * @returns {integer} The number of questions in a subtest which the user has answered.
 */
export default function countAnsweredQuestions(answersByItem) {
  let count = 0
  forOwn(answersByItem, (val) => {
    if (val) {
      count++
    }
  })
  return count
}


// WEBPACK FOOTER //
// ./src/helpers/assessment/countAnsweredQuestions.js